import React from 'react';
import Elo from '../../assets/images/cards/elo.png';
import Barcode from '../../assets/images/boleto.png';
import Visa from '../../assets/images/cards/visa.png';
import Amex from '../../assets/images/cards/amex.png';
import Hipercard from '../../assets/images/cards/hipercard.png';
import TicketLog from '../../assets/images/cards/ticket-log.png';
import MasterCard from '../../assets/images/cards/mastercard.png';


const CardBrandIcon = ({ brand }) => {
    const cardBrand = brand.toLowerCase();
    let image;
    if (cardBrand.includes('visa')) {
        image = Visa;
    } else if (cardBrand.includes('master')) {
        image = MasterCard;
    } else if (cardBrand.includes('amex')) {
        image = Amex;
    } else if (cardBrand.includes('hiper')) {
        image = Hipercard;
    } else if (cardBrand.includes('elo')) {
        image = Elo;
    } else if (cardBrand.includes('slip')) {
        image = Barcode;
    } else if (cardBrand.includes('ticketlog')) {
        image = TicketLog;
    } else {
        image = 'none';
    }
    return (
        <img
            className="mr-2"
            src={image}
            width="25px"
            alt={`Bandeira ${brand}`}
        />
    );
}

export default CardBrandIcon;



// WEBPACK FOOTER //
// ./src/components/Shared/CardBrandIcon.js